<template>
  <div id="footer" class="container-fluid">
    <!-- <div class="logo">
      <img src="@/assets/img/logo_black.png" alt="logo图">
    </div> -->
    <br>
    <p class="title">四川佳石信息技术有限公司</p>
    <p class="address_tel_fax">
      <span>地址：四川省成都市青羊区蜀金路1号金沙万瑞中心3栋6层602号</span>
      <span>电话：028-87657108</span>
      <span>邮箱：li.yuan@jiasion.cn</span>
      
      <!-- <span>Fax：8888-88888888</span> -->

    </p>
    <!-- <p class="email_wx">
      <span>邮箱：li.yuan@jiasion.cn</span>
      <span>公司微信号：ilyk_gg</span>
    </p> -->
    <a href="https://beian.miit.gov.cn/#/Integrated/index">Copyright &copy; 蜀ICP备2022012014号-1</a>
    <!-- <p class="copy">Copyright &copy; 蜀ICP备2022012014号-1</p> -->
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 20px;
  height: 10px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue